import { render } from "./FooterLayout.vue?vue&type=template&id=79053264&scoped=true"
import script from "./FooterLayout.vue?vue&type=script&lang=js"
export * from "./FooterLayout.vue?vue&type=script&lang=js"

import "./FooterLayout.vue?vue&type=style&index=0&id=79053264&scoped=true&lang=css"

import exportComponent from "/pro/vue/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79053264"]])

export default __exports__